<section class="calculate">
  <form [formGroup]="form" class="calculate-wrapper">
    <app-calculate-widget
      (calculateChangeEvent)="calculateChangeHandler($event)"
      [amount]="amount"
      [product]="mockProduct"
      [term]="term"
      formGroupName="calculate"
    ></app-calculate-widget>
    <div class="calculate-container">
      <div class="preview">
        <app-promo-code
          [maxCodeLength]="MIN_CODE_LENGTH"
          [placeholder]="'LOAN.BOOKING.PROMO_PLACEHOLDER' | translate"
          classes="text-left mb-3"
          formControlName="code"
        ></app-promo-code>
        <div class="calculate-button">
          <app-button
            (clickEvent)="navigateToCreditUrl()"
            [label]="'CALCULATE.BTN' | translate"
            class="w-100"
            classes="fs-15"
            color="secondary"
            size="w100"
            type="button"
          >
          </app-button>
        </div>
      </div>
      <div class="schedule mt-2">
        <div class="schedule-header">
          <div
            (click)="showDetails('DETAILS')"
            [class.active]="activeTab === 'DETAILS'"
            class="schedule-btn schedule-btn_details text-center d-flex justify-content-center align-items-center cursor-pointer position-relative"
          >
            <span class="label">{{ 'OUTSOURCE_NOTICE.BTN' | translate }}</span>
          </div>
        </div>
        <div *ngIf="preview$ | async as preview" class="schedule-container">
          <div *ngIf="activeTab === 'DETAILS'" class="schedule-content schedule-content_details">
            <div class="content-inner">
              <div class="preview-row">
                <p class="preview-name">Стандартна процентна ставка:</p>
                <p class="preview-value">{{ mockProduct.interest }} %</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">{{ 'CALCULATE_COMMISSION' | translate }}:</p>
                <p class="preview-value">{{ mockProduct.issueCommissionRate }} %</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">Періодичність сплати платежу:</p>
                <p class="preview-value">{{ term }} днів</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">Сума платежу першого платіжного періоду:</p>
                <p class="preview-value">{{ preview.firstPaymentPeriodAmount }} грн</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">Сума платежів:</p>
                <p class="preview-value">{{ preview.percentByTerm }} грн</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">
                  <span class="label"
                    >Реальна річна процентна ставка:
                    <span
                      class="preview-icon"
                      matTooltip="Розрахована, відповідно до Постанови Правління Національного банку
                               України 11.02.2021 № 16 з використовуванням функцією XIRR програмного
                               продукту Microsoft Excel."
                      matTooltipClass="preview-tooltip"
                      matTooltipPosition="above"
                      >!</span
                    >
                  </span>
                </p>
                <p class="preview-value">{{ preview.details.firstPayment.realPercentPerYear }} %</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">Загальна кількість платежів:</p>
                <p class="preview-value">{{ paymentsQuantity(preview.term) }}</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">Загальні витрати за кредитом в розрахунку на 120 днів:</p>
                <p class="preview-value">{{ preview.percentAmount | number:'1.2-2' }} грн</p>
              </div>
              <div class="preview-row">
                <p class="preview-name">Загальна вартість кредиту в розрахунку на 120 днів:</p>
                <p class="preview-value">{{ preview.totalAmount | number:'1.2-2' }} грн</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<p
  [innerHTML]=" 'CALCULATE_COMMISSION_INFO' | translate: { first: translateParamsStar.first, second: translateParamsStar.second }  "
  class="calculate-text mt-2"
></p>
